import { create } from '../../utils/create';
export class Details {
    constructor(parent, go, controller, header) {
        this.update = (props) => {
            this.render(props);
        };
        this.render = (props) => {
            var _a, _b, _c, _d;
            (_a = this.component) === null || _a === void 0 ? void 0 : _a.remove();
            const img = create({
                tagName: 'img',
                classNames: 'product__card__img-img',
                dataAttr: [
                    ['src', ((_c = (_b = props === null || props === void 0 ? void 0 : props.item) === null || _b === void 0 ? void 0 : _b.images) === null || _c === void 0 ? void 0 : _c.at(0)) || ''],
                    ['alt', 'Main product image']
                ]
            });
            const mainImg = create({
                tagName: 'div',
                classNames: 'product__card__img',
                children: [img]
            });
            const slidesBlock = props === null || props === void 0 ? void 0 : props.item.images.map((image) => {
                const slides = create({
                    tagName: 'div',
                    classNames: 'product__slides-container',
                    children: [
                        create({
                            tagName: 'img',
                            classNames: 'product__slides-image',
                            dataAttr: [
                                ['src', image || ''],
                                ['alt', 'Product image']
                            ]
                        })
                    ]
                });
                slides.addEventListener('click', () => {
                    img.setAttribute('src', image);
                });
                return slides;
            });
            const slides = create({
                tagName: 'div',
                classNames: 'product__slides',
                children: slidesBlock
            });
            const descriptioFields = {
                popularity: 'Popularity',
                stock: 'Stock',
                animeName: 'From',
                category: 'Category',
                description: 'Description'
            };
            const descriptionItems = Object.entries(descriptioFields).map(([key, value]) => {
                var _a;
                return create({
                    tagName: 'div',
                    classNames: 'product__card__descr-item',
                    children: [
                        create({
                            tagName: 'div',
                            classNames: 'product__card__descr-item__title',
                            children: `${value}: `
                        }),
                        create({
                            tagName: 'div',
                            classNames: 'product__card__descr-item__text',
                            children: `${(_a = props === null || props === void 0 ? void 0 : props.item) === null || _a === void 0 ? void 0 : _a[key]}`
                        })
                    ]
                });
            });
            const description = create({
                tagName: 'div',
                classNames: 'product__card__descr',
                children: descriptionItems
            });
            const addToCartBtnDetails = create({
                tagName: 'a',
                classNames: 'btn'
            });
            const cartProduct = {
                product: props === null || props === void 0 ? void 0 : props.item,
                amount: 1
            };
            addToCartBtnDetails.addEventListener('click', () => {
                if (addToCartBtnDetails.textContent === 'Add to cart') {
                    this.controller.pushNewCartProduct(cartProduct);
                    this.header.renderCartWrapper();
                }
                else {
                    this.controller.getCurrentCartProducts().map((i, index) => {
                        if (i.product.id === props.item.id) {
                            this.controller.removeCartProduct(index);
                            this.header.renderCartWrapper();
                        }
                    });
                }
                this.render(props);
            });
            if (this.controller.getCurrentCartProducts().length === 0) {
                addToCartBtnDetails.textContent = 'Add to cart';
            }
            else {
                if (this.controller.getCurrentCartProducts().filter((i) => i.product.id === props.item.id)
                    .length !== 0) {
                    addToCartBtnDetails.textContent = 'Drop from cart';
                }
                else {
                    addToCartBtnDetails.textContent = 'Add to cart';
                }
            }
            const buyNowBtn = create({
                tagName: 'a',
                dataAttr: [['href', '/cart']],
                classNames: 'btn',
                children: 'BUY NOW'
            });
            buyNowBtn.addEventListener('click', (e) => {
                if (addToCartBtnDetails.textContent === 'Add to cart') {
                    this.controller.pushNewCartProduct(cartProduct);
                }
                this.go(e, () => this.controller.openPopup());
                this.controller.openPopup();
            });
            const add = create({
                tagName: 'div',
                classNames: 'product__card__add',
                children: [
                    create({
                        tagName: 'span',
                        classNames: 'product__card__add-price',
                        children: `${(_d = props === null || props === void 0 ? void 0 : props.item) === null || _d === void 0 ? void 0 : _d.price} $`
                    }),
                    addToCartBtnDetails,
                    buyNowBtn
                ]
            });
            const slidesNImage = create({
                tagName: 'div',
                classNames: 'product__images-wrapper',
                children: [slides, mainImg]
            });
            const productitem = create({
                tagName: 'div',
                classNames: 'product__card-info',
                children: [slidesNImage, description, add]
            });
            const linkHome = create({
                tagName: 'a',
                classNames: 'link__nav-item',
                dataAttr: [['href', '/filter']],
                children: 'STORE'
            });
            linkHome.addEventListener('click', this.go);
            this.component = create({
                tagName: 'div',
                classNames: 'details__wrapper',
                children: [
                    create({
                        tagName: 'div',
                        classNames: 'link__nav',
                        children: [
                            create({
                                tagName: 'div',
                                classNames: 'link__nav-wrapper',
                                children: [
                                    linkHome,
                                    create({
                                        tagName: 'span',
                                        children: ' >> '
                                    }),
                                    create({
                                        tagName: 'a',
                                        classNames: 'link__nav-item',
                                        children: `${props === null || props === void 0 ? void 0 : props.item.category}`
                                    }),
                                    create({
                                        tagName: 'span',
                                        children: ' >> '
                                    }),
                                    create({
                                        tagName: 'a',
                                        classNames: 'link__nav-item',
                                        children: `${props === null || props === void 0 ? void 0 : props.item.animeName}`
                                    }),
                                    create({
                                        tagName: 'span',
                                        children: ' >> '
                                    }),
                                    create({
                                        tagName: 'a',
                                        classNames: 'link__nav-item',
                                        children: `${props === null || props === void 0 ? void 0 : props.item.name}`
                                    })
                                ]
                            })
                        ]
                    }),
                    create({
                        tagName: 'div',
                        classNames: 'product__card',
                        children: [
                            create({
                                tagName: 'div',
                                classNames: 'product__card-title',
                                children: [
                                    create({
                                        tagName: 'h1',
                                        children: `${props === null || props === void 0 ? void 0 : props.item.name}`
                                    })
                                ]
                            }),
                            productitem
                        ]
                    })
                ],
                parent: this.parent
            });
        };
        this.parent = parent;
        this.component = null;
        this.go = go;
        this.controller = controller;
        this.header = header;
    }
}
